import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ project, index, onOpen }) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, delay: (index % 2) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      onClick={() => onOpen(project)}
      data-testid={`project-card-${project.id}`}
      className="group flex flex-col overflow-hidden rounded-2xl bg-[#0A0A0A] border border-white/[0.07] cursor-pointer transition-colors duration-500 hover:border-white/20"
    >
      {/* clean screenshot — no text overlay */}
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={project.thumbnail}
          alt={project.title}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
        />
        {/* subtle hover veil + open affordance */}
        <div className="absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/20" />
        <span className="absolute top-4 right-4 flex h-9 w-9 items-center justify-center rounded-full bg-white text-black opacity-0 -translate-y-1 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
          <ArrowUpRight size={18} strokeWidth={2.4} />
        </span>
      </div>

      {/* title + copy below the image */}
      <div className="p-6 md:p-7">
        <div className="flex items-center justify-between gap-3">
          <h3 className="font-[Outfit] text-2xl md:text-3xl font-semibold tracking-tight text-white">
            {project.title}
          </h3>
          <span className="shrink-0 font-mono text-[10px] uppercase tracking-[0.2em] text-white/55 border border-white/10 rounded-full px-3 py-1.5">
            {project.industry}
          </span>
        </div>
        <p className="mt-2.5 text-sm leading-relaxed text-white/55 line-clamp-2">
          {project.description}
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {project.tags.map((t) => (
            <span
              key={t}
              className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/45 border border-white/10 rounded-full px-2.5 py-1"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};
